<app-larged-tuile
  icon="fa-kit fa-picto-pacpoly"
  [title]="
    titles[actionStack!.getValue('ppPModeFonctionnementTemperature')]
      | translate
  "
  [buttons]="buttons"
  [status]="
    buttonMode[this.actionStack!.getValue('ppSEtatFonctionnementPAC')].title!
      | translate
  "
  [mode]="
    this.actionStack!.getValue('ppPTemperatureConsigne') === 0
      ? ''
      : getTemperature(
          this.actionStack!.getValue('ppPTemperatureConsigne') / 10,
          0
        )
  "
  [statusMode]="
    buttonMode[this.actionStack!.getValue('ppSEtatFonctionnementPAC')].status!
  "
  [selectItem]="this.actionStack!.getValue('ppCModeFonctionnement')"
  (onPressSetting)="this.openProductModal()"
  (onChange)="
    this.actionStack!.editValue(
      P00039DataRxTxIndex.PACPOLY_Controle,
      'ppCModeFonctionnement',
      $event
    );
    this.actionStack!.commit()
  "
>
</app-larged-tuile>
